var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title-icon",class:{'background': _vm.hasBackground}},[(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }